import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import * as Sentry from "@sentry/angular";
import { LocalStorageService } from "ngx-webstorage";

@Injectable({
    providedIn: 'root'
})
export class AppLocalStateService {


    constructor(private localStorageService: LocalStorageService) {
    }

    setupSentryUser() {
        if (environment.production) {
            try {
                Sentry.setUser({
                    id: this.localStorageService.retrieve('uid'),
                    sessionToken: this.localStorageService.retrieve('session_token'),
                    installation: this.localStorageService.retrieve('installationId'),
                });
            } catch (e) {
                console.error(e, 'Error setting up sentry user');
            }
        }
    }
}
